module.exports = __webpack_public_path__ + "static/media/success-confetti.80526368.svg";